export interface AbModalConfigInterface {
  autoOpen: boolean;
  hideBodyOverflow: boolean;
  handleBackBrowser: boolean;
  attributes: AbModalAttributes;
  id: string;
  handlers?: {
    onOpen?: () => void;
    onClose?: () => void;
  }
}

export interface AbModalAttributes {
  classesModal: string;
  classesBackdrop: string;
  classesInner: string;
  classesWrapper: string;
  header?: IAbModalHeaderConfig;
}

export interface IAbModalHeaderConfig {
  show: boolean;
  classes?: string;
  text?: string;
  closeButtonText?: string;
  closeButton?: boolean;
}

export enum AbModalSizingClassesEnum {
  SMALL = 'ab-modal--sm',
  MEDIUM = 'ab-modal--md',
  LARGE = 'ab-modal--lg',
  FULL = 'ab-modal--full',
}